const headers = {
  "Content-Type": "application/json",
  Accept: "application/json",
  "X-Requested-With": "XMLHttpRequest"
};

export async function getPseudonym(patient) {
  const fhirPatient = {
    resourceType: "Patient",
    identifier: {
      system: "http://deeppat.cl/fhir/patient-rut",
      value: patient.rut
    },
    name: {
      text: patient.name
    }
  };
  const url = "";
  const body = fhirPatient;
  // await fetch(url, { method: "post", headers, body });

  return 5;
}

export async function storeContribution(jwt, form) {
  if (jwt) {
    headers["Authorization"] = `Bearer ${jwt}`;
  }

  let body = {
    dicom_study_instance_uid: form.image.dicomStudyInstanceUid,
    dicom_series_instance_uid: form.image.dicomSeriesInstanceUid,
    wsi_mpp_x: form.image.mppX,
    wsi_mpp_y: form.image.mppY,
    scanner_manufacturer: form.image.scanner.manufacturer,
    scanner_model: form.image.scanner.model,
    pixel_depth: form.image.pixelDepth,
    organization: form.owner.organization.id,
    magnifications: JSON.stringify(form.image.magnifications),
    date_contribution: form.image.dateOfContribution,
    date_wsi_scanning: form.image.dateOfSlideScanning,
    date_slide_creation: form.image.dateOfSlideCreation,
    sample_procedure: form.pathology.sampleProcedure,
    diagnose: form.pathology.diagnose,
    type_of_tissue: form.pathology.tissueType,
    staining: form.pathology.staining,
    body_part: form.pathology.bodyPart,
    patient: form.patient
  };
  body = JSON.stringify(body);

  return await fetch(process.env.VUE_APP_DATA_TRUSTEE_URL, {
    method: "post",
    headers,
    body
  });
}
